// Routes data structure with detailed information about each route
export const routes = [
  {
    id: 'ruta-norte-galicia',
    name: 'Ruta Norte de Galicia: Playas, Miradores y Encanto Atlántico',
    description: 'Un recorrido relajado por las mejores playas, miradores y pueblos del norte de Galicia, con sugerencias gastronómicas y paisajes inolvidables.',
    duration: 'weekend',
    days: 3,
    totalDistance: 220, // Aproximado
    difficulty: 'fácil',
    bestFor: ['parejas', 'familias', 'grupos'],
    interests: ['beach', 'nature', 'food', 'viewpoint', 'town', 'culture'],
    travelStyle: 'relaxed',
    groupSize: ['1-2', '3-4', '5+'],
    mapUrl: 'https://www.google.com/maps/d/embed?mid=1zHlz1edvMNmeYRpBrOGMzFLfgn8HAyo&ehbc=2E312F',
    highlights: [
      'Playa de Las Catedrales',
      'Faro de Cabo Ortegal',
      'Punta do Fuciño do Porco',
      'Ortigueira',
      'Restaurante Nito'
    ],
    itinerary: [
      {
        day: 1,
        title: 'De Ribadeo a Viveiro: Playas y acantilados',
        description: 'Comienza en Ribadeo y explora la famosa Playa de Las Catedrales. Continúa por la costa visitando playas y acantilados espectaculares.',
        stops: [
          {
            name: 'Playa de Las Catedrales',
            type: 'beach',
            description: 'Recuerda que hay que reservar previamente en verano.'
          },
          {
            name: 'Praia do Esteiro',
            type: 'beach'
          },
          {
            name: 'Praia de Morouzos',
            type: 'beach'
          },
          {
            name: 'Viveiro Centro Comercial Histórico',
            type: 'town',
            description: 'Casco histórico precioso.'
          }
        ],
        nearby: [
          {
            name: 'Praia de Xilloi',
            type: 'beach'
          },
          {
            name: 'Playa de Caolín',
            type: 'beach'
          },
          {
            name: 'Pozo da Ferida',
            type: 'nature'
          },
          {
            name: 'Souto da Retorta',
            type: 'nature'
          },
          {
            name: 'Catedral-Basílica de la Asunción de Mondoñedo',
            type: 'culture'
          },
          {
            name: 'Restaurante A Lonxa',
            type: 'food'
          },
          {
            name: 'Hotel Restaurante Javier Montero',
            type: 'food'
          }
        ]
      },
      {
        day: 2,
        title: 'Miradores y pueblos marineros',
        description: 'Disfruta de los mejores miradores y pueblos con encanto de la costa norte.',
        stops: [
          {
            name: 'Punta do Fuciño do Porco',
            type: 'viewpoint'
          },
          {
            name: 'Ortigueira',
            type: 'town'
          },
          {
            name: 'Cariño',
            type: 'town'
          },
          {
            name: 'Faro de Cabo Ortegal',
            type: 'viewpoint'
          }
        ],
        nearby: [
          {
            name: 'Mirador de Miranda',
            type: 'viewpoint'
          },
          {
            name: 'Miradoiro do Cabo Ortegal',
            type: 'viewpoint'
          },
          {
            name: 'Malpica',
            type: 'town'
          },
          {
            name: 'Cedeira',
            type: 'town'
          },
          {
            name: 'San Andrés de Teixido',
            type: 'nature'
          },
          {
            name: 'Sierra de la Capelada',
            type: 'nature'
          },
          {
            name: 'Restaurante MAREA',
            type: 'food'
          },
          {
            name: 'Restaurante A Mirandilla',
            type: 'food'
          }
        ]
      },
      {
        day: 3,
        title: 'Playas salvajes y sugerencias gastronómicas',
        description: 'Relájate en playas menos conocidas y disfruta de la gastronomía local.',
        stops: [
          {
            name: 'Playa Pantín',
            type: 'beach'
          },
          {
            name: 'Praia de Santa Comba',
            type: 'beach'
          },
          {
            name: 'Restaurante Nito',
            type: 'food',
            description: 'Famoso por su marisco y pescado fresco.'
          }
        ],
        nearby: [
          {
            name: 'Playa es Doniños',
            type: 'beach'
          },
          {
            name: 'Praia de Balarés',
            type: 'beach'
          },
          {
            name: 'Chiringuito Doniños',
            type: 'food'
          },
          {
            name: 'Mesón Muiño Kilowatio',
            type: 'food'
          },
          {
            name: 'La Bodeguita del Puerto',
            type: 'food'
          },
          {
            name: 'A Taberna Do Puntal',
            type: 'food'
          }
        ]
      }
    ]
  },
  {
    id: 'ruta-norte-galicia-semana',
    name: 'Ruta Norte de Galicia: 7 días de playas, miradores y pueblos',
    description: 'Una semana completa explorando lo mejor del norte de Galicia: playas, miradores, pueblos y gastronomía.',
    duration: 'week',
    days: 7,
    totalDistance: 400, // Aproximado
    difficulty: 'fácil',
    bestFor: ['parejas', 'familias', 'grupos'],
    interests: ['beach', 'nature', 'food', 'viewpoint', 'town', 'culture'],
    travelStyle: 'relaxed',
    groupSize: ['1-2', '3-4', '5+'],
    mapUrl: 'https://www.google.com/maps/d/embed?mid=1zHlz1edvMNmeYRpBrOGMzFLfgn8HAyo&ehbc=2E312F',
    highlights: [
      'Playa de Las Catedrales',
      'Faro de Cabo Ortegal',
      'Punta do Fuciño do Porco',
      'Ortigueira',
      'San Andrés de Teixido',
      'Playa Pantín',
      'Restaurante Nito'
    ],
    itinerary: [
      {
        day: 1,
        title: 'Ribadeo y Las Catedrales',
        description: 'Comienza en Ribadeo y explora la famosa Playa de Las Catedrales, con tiempo para disfrutar de la costa y la gastronomía local.',
        stops: [
          {
            name: 'Playa de Las Catedrales',
            type: 'beach',
            description: 'Recuerda que hay que reservar previamente en verano.'
          },
          {
            name: 'Restaurante A Lonxa',
            type: 'food',
            googleMapsUrl: 'https://www.google.com/maps?q=43.655483,-7.3529585'
          }
        ],
        nearby: [
          {
            name: 'Hotel Restaurante Javier Montero',
            type: 'food',
            googleMapsUrl: 'https://www.google.com/maps?q=43.5425875,-7.0403859'
          }
        ]
      },
      {
        day: 2,
        title: 'Costa de Lugo: Viveiro y alrededores',
        description: 'Explora el casco histórico de Viveiro y las playas cercanas.',
        stops: [
          {
            name: 'Viveiro Centro Comercial Histórico',
            type: 'town',
            description: 'Casco histórico precioso.'
          },
          {
            name: 'Praia do Esteiro',
            type: 'beach',
            googleMapsUrl: 'https://www.google.com/maps?q=43.7114319,-7.5589162'
          },
          {
            name: 'Praia de Morouzos',
            type: 'beach',
            googleMapsUrl: 'https://www.google.com/maps?q=43.7029768,-7.8431379'
          }
        ],
        nearby: [
          {
            name: 'Praia de Xilloi',
            type: 'beach',
            googleMapsUrl: 'https://www.google.com/maps?q=43.7432545,-7.6531156'
          },
          {
            name: 'Playa de Caolín',
            type: 'beach',
            googleMapsUrl: 'https://www.google.com/maps?q=43.7418368,-7.6734462'
          },
          {
            name: 'Pozo da Ferida',
            type: 'nature',
            googleMapsUrl: 'https://www.google.com/maps?q=43.615512,-7.5347633'
          },
          {
            name: 'Souto da Retorta',
            type: 'nature',
            googleMapsUrl: 'https://www.google.com/maps?q=43.6126253,-7.5903407'
          },
          {
            name: 'Catedral-Basílica de la Asunción de Mondoñedo',
            type: 'culture',
            googleMapsUrl: 'https://www.google.com/maps?q=43.4281587,-7.362713'
          }
        ]
      },
      {
        day: 3,
        title: 'Ortigueira y miradores',
        description: 'Disfruta de los miradores y el encanto de Ortigueira.',
        stops: [
          {
            name: 'Ortigueira',
            type: 'town',
            googleMapsUrl: 'https://www.google.com/maps?q=43.6831622,-7.8521653'
          },
          {
            name: 'Punta do Fuciño do Porco',
            type: 'viewpoint',
            googleMapsUrl: 'https://www.google.com/maps?q=43.717041,-7.6064965'
          },
          {
            name: 'Mirador de Miranda',
            type: 'viewpoint',
            googleMapsUrl: 'https://www.google.com/maps?q=43.7165076,-7.8956035'
          }
        ],
        nearby: [
          {
            name: 'Restaurante A Mirandilla',
            type: 'food',
            googleMapsUrl: 'https://www.google.com/maps?q=43.5574341,-7.1041326'
          }
        ]
      },
      {
        day: 4,
        title: 'Cedeira y San Andrés de Teixido',
        description: 'Explora Cedeira y el mágico San Andrés de Teixido.',
        stops: [
          {
            name: 'Cedeira',
            type: 'town',
            googleMapsUrl: 'https://www.google.com/maps?q=43.6607861,-8.0537698'
          },
          {
            name: 'San Andrés de Teixido',
            type: 'nature',
            googleMapsUrl: 'https://www.google.com/maps?q=43.7090435,-7.9838046'
          },
          {
            name: 'Sierra de la Capelada',
            type: 'nature',
            googleMapsUrl: 'https://www.google.com/maps?q=43.7319444,-7.9341667'
          }
        ],
        nearby: [
          {
            name: 'Restaurante MAREA',
            type: 'food',
            googleMapsUrl: 'https://www.google.com/maps?q=43.7410301,-7.8698597'
          }
        ]
      },
      {
        day: 5,
        title: 'Ferrolterra: playas y surf',
        description: 'Disfruta de las playas de Ferrolterra y el ambiente surfista.',
        stops: [
          {
            name: 'Playa Pantín',
            type: 'beach',
            googleMapsUrl: 'https://www.google.com/maps?q=43.6392834,-8.1144005'
          },
          {
            name: 'Playa es Doniños',
            type: 'beach',
            googleMapsUrl: 'https://www.google.com/maps?q=43.4980314,-8.318768'
          },
          {
            name: 'Chiringuito Doniños',
            type: 'food',
            googleMapsUrl: 'https://www.google.com/maps?q=43.5035782,-8.318282'
          }
        ],
        nearby: [
          {
            name: 'Mesón Muiño Kilowatio',
            type: 'food',
            googleMapsUrl: 'https://www.google.com/maps?q=43.6593257,-8.0570443'
          }
        ]
      },
      {
        day: 6,
        title: 'Costa Ártabra y Malpica',
        description: 'Explora la Costa Ártabra y el encanto de Malpica.',
        stops: [
          {
            name: 'Malpica',
            type: 'town',
            googleMapsUrl: 'https://www.google.com/maps?q=43.3230079,-8.8106438'
          },
          {
            name: 'Praia de Balarés',
            type: 'beach',
            googleMapsUrl: 'https://www.google.com/maps?q=43.2412366,-8.9421291'
          }
        ],
        nearby: [
          {
            name: 'A Taberna Do Puntal',
            type: 'food',
            googleMapsUrl: 'https://www.google.com/maps?q=43.6337321,-8.0490638'
          }
        ]
      },
      {
        day: 7,
        title: 'Relax y gastronomía',
        description: 'Último día para relajarse y disfrutar de la gastronomía local.',
        stops: [
          {
            name: 'Restaurante Nito',
            type: 'food',
            description: 'Famoso por su marisco y pescado fresco.',
            googleMapsUrl: 'https://www.google.com/maps?q=43.6856547,-7.5807267'
          },
          {
            name: 'Praia de Santa Comba',
            type: 'beach',
            googleMapsUrl: 'https://www.google.com/maps?q=43.5560189,-8.2964411'
          }
        ],
        nearby: [
          {
            name: 'La Bodeguita del Puerto',
            type: 'food',
            googleMapsUrl: 'https://www.google.com/maps?q=43.7382368,-7.6747435'
          }
        ]
      }
    ]
  },
  {
    id: 'ruta-ribeira-sacra',
    name: 'Ruta Ribeira Sacra: Monasterios, Miradores y Viñedos',
    description: 'Descubre los monasterios, miradores, cascadas y bodegas más emblemáticos de la Ribeira Sacra en 3 días inolvidables.',
    duration: 'weekend',
    days: 3,
    totalDistance: 120, // Aproximado
    difficulty: 'fácil',
    bestFor: ['parejas', 'familias', 'grupos'],
    interests: ['nature', 'viewpoint', 'culture', 'food', 'wine'],
    travelStyle: 'relaxed',
    groupSize: ['1-2', '3-4', '5+'],
    mapUrl: 'https://www.google.com/maps/d/embed?mid=1riqmoDha1WagiJ-SlUwwVHjO9DPptxA&ehbc=2E312F',
    highlights: [
      'Monasterio de Santo Estevo de Ribas de Sil',
      'Balcóns de Madrid',
      'Mirador de Vilouxe do Sil',
      'Bodegas Regina Viarum',
      'Cascada de Augacaída'
    ],
    itinerary: [
      {
        day: 1,
        title: 'Monasterio y Embarcadero',
        description: 'Visita el Monasterio de Santo Estevo y disfruta de un paseo en barco por el Sil.',
        stops: [
          { name: 'Monasterio de Santo Estevo de Ribas de Sil', type: 'culture' },
          { name: 'Embarcadero de Santo Estevo', type: 'nature' },
          { name: 'Cascada de San Esteban', type: 'nature' }
        ],
        nearby: [
          { name: 'Restaurante O Campanario', type: 'food' },
          { name: 'Cascada de Augacaída', type: 'nature' }
        ]
      },
      {
        day: 2,
        title: 'Miradores y Viñedos',
        description: 'Recorre los miradores más espectaculares y visita bodegas locales.',
        stops: [
          { name: 'Mirador de Vilouxe do Sil', type: 'viewpoint' },
          { name: 'Balcóns de Madrid', type: 'viewpoint' },
          { name: 'Mirador de Pena do Castelo', type: 'viewpoint' },
          { name: 'Bodegas Regina Viarum', type: 'wine' },
          { name: 'ADEGA ALGUEIRA', type: 'wine' }
        ],
        nearby: [
          { name: 'Casa Grande De Cristosende', type: 'culture' },
          { name: 'Bodegas Petrón', type: 'wine' },
          { name: 'Restaurante O Curtiñeiro', type: 'food' }
        ]
      },
      {
        day: 3,
        title: 'Termas, naturaleza y gastronomía',
        description: 'Relájate en las termas y disfruta de la naturaleza y la gastronomía local.',
        stops: [
          { name: 'Termas Outariz', type: 'nature' },
          { name: 'Termas Prexigueiro', type: 'nature' },
          { name: 'Praia da Coba', type: 'nature' }
        ],
        nearby: [
          { name: 'Antonio do Nicho', type: 'food' },
          { name: 'Finca Scintilla', type: 'food' },
          { name: 'A Faragulla', type: 'food' },
          { name: 'OS PENDELLOS', type: 'food' },
          { name: 'A Mirada Maxica', type: 'viewpoint' },
          { name: 'Miradoiro de Pesqueiras', type: 'viewpoint' }
        ]
      }
    ]
  },
  {
    id: 'ruta-geres-norte-portugal',
    name: 'Ruta Gerês y Norte de Portugal: Naturaleza y Miradores',
    description: 'Explora los paisajes, cascadas y miradores más espectaculares del norte de Portugal y el Parque Nacional da Peneda-Gerês en 3 días llenos de naturaleza y aventura.',
    duration: 'weekend',
    days: 3,
    totalDistance: 180, // Aproximado
    difficulty: 'media',
    bestFor: ['parejas', 'familias', 'grupos'],
    interests: ['nature', 'viewpoint', 'culture', 'food'],
    travelStyle: 'adventure',
    groupSize: ['1-2', '3-4', '5+'],
    mapUrl: 'https://www.google.com/maps/d/embed?mid=1cDC4OxReCZQZYPQ34E0HSUsJXrJ-0gM&ehbc=2E312F',
    highlights: [
      'Cascada de Varzeas',
      'Poço Azul do Gerês',
      'Mirador de la Pedra Bela',
      'Pitões das Junias',
      'Soajo'
    ],
    itinerary: [
      {
        day: 1,
        title: 'Cascadas y pozas naturales',
        description: 'Descubre las cascadas y pozas más famosas del Gerês.',
        stops: [
          { name: 'Cascada de Varzeas', type: 'nature' },
          { name: 'Poço Azul do Gerês', type: 'nature' },
          { name: 'Cascada del Arado', type: 'nature' }
        ],
        nearby: [
          { name: 'Cascada de San Miguel', type: 'nature' },
          { name: 'Xertelo', type: 'nature' }
        ]
      },
      {
        day: 2,
        title: 'Miradores y pueblos con encanto',
        description: 'Recorre los mejores miradores y visita pueblos tradicionales.',
        stops: [
          { name: 'Mirador de la Pedra Bela', type: 'viewpoint' },
          { name: 'Viewpoint Boneca', type: 'viewpoint' },
          { name: 'Pitões das Junias', type: 'culture' },
          { name: 'Soajo', type: 'culture' }
        ],
        nearby: [
          { name: 'Santuario del Sagrado Corazón de Jesús / Monte de Santa Lucía', type: 'viewpoint' },
          { name: 'Castro de São Lourenço', type: 'culture' }
        ]
      },
      {
        day: 3,
        title: 'Playas fluviales y gastronomía',
        description: 'Relájate en playas fluviales y disfruta de la gastronomía local.',
        stops: [
          { name: 'Praia do Cabedelo', type: 'nature' },
          { name: 'Praia de Moledo', type: 'nature' },
          { name: 'Praia de Ofir', type: 'nature' }
        ],
        nearby: [
          { name: 'Bamboo & Coconut Park', type: 'nature' },
          { name: 'Adega do Ermitão', type: 'food' },
          { name: 'Le Babachris', type: 'food' }
        ]
      }
    ]
  },
  {
    id: 'ruta-geres-norte-portugal-semana',
    name: 'Ruta Gerês y Norte de Portugal: 7 días de naturaleza y cultura',
    description: 'Una semana completa explorando cascadas, miradores, pueblos y playas fluviales del norte de Portugal y el Parque Nacional da Peneda-Gerês.',
    duration: 'week',
    days: 7,
    totalDistance: 350, // Aproximado
    difficulty: 'media',
    bestFor: ['parejas', 'familias', 'grupos'],
    interests: ['nature', 'viewpoint', 'culture', 'food'],
    travelStyle: 'adventure',
    groupSize: ['1-2', '3-4', '5+'],
    mapUrl: 'https://www.google.com/maps/d/embed?mid=1cDC4OxReCZQZYPQ34E0HSUsJXrJ-0gM&ehbc=2E312F',
    highlights: [
      'Cascada de Varzeas',
      'Poço Azul do Gerês',
      'Mirador de la Pedra Bela',
      'Pitões das Junias',
      'Soajo',
      'Praia do Cabedelo',
      'Castro de São Lourenço'
    ],
    itinerary: [
      {
        day: 1,
        title: 'Inicio y primeras cascadas',
        description: 'Comienza la ruta con las primeras cascadas y pozas naturales.',
        stops: [
          { name: 'Cascada de Varzeas', type: 'nature' },
          { name: 'Poço Azul do Gerês', type: 'nature' }
        ],
        nearby: [
          { name: 'Cascada de San Miguel', type: 'nature' }
        ]
      },
      {
        day: 2,
        title: 'Cascada del Arado y Xertelo',
        description: 'Explora la famosa Cascada del Arado y el entorno de Xertelo.',
        stops: [
          { name: 'Cascada del Arado', type: 'nature' },
          { name: 'Xertelo', type: 'nature' }
        ],
        nearby: [
          { name: 'Cascada de San Miguel', type: 'nature' }
        ]
      },
      {
        day: 3,
        title: 'Miradores del Gerês',
        description: 'Disfruta de los mejores miradores del parque.',
        stops: [
          { name: 'Mirador de la Pedra Bela', type: 'viewpoint' },
          { name: 'Viewpoint Boneca', type: 'viewpoint' }
        ],
        nearby: [
          { name: 'A Mirada Maxica', type: 'viewpoint' }
        ]
      },
      {
        day: 4,
        title: 'Pueblos con encanto',
        description: 'Visita los pueblos tradicionales de la zona.',
        stops: [
          { name: 'Pitões das Junias', type: 'culture' },
          { name: 'Soajo', type: 'culture' }
        ],
        nearby: [
          { name: 'Santuario del Sagrado Corazón de Jesús / Monte de Santa Lucía', type: 'viewpoint' }
        ]
      },
      {
        day: 5,
        title: 'Castros y parques',
        description: 'Descubre castros y parques únicos.',
        stops: [
          { name: 'Castro de São Lourenço', type: 'culture' },
          { name: 'Bamboo & Coconut Park', type: 'nature' }
        ],
        nearby: [
          { name: 'Moinhos de Vento', type: 'culture' }
        ]
      },
      {
        day: 6,
        title: 'Playas fluviales',
        description: 'Relájate en las mejores playas fluviales del norte de Portugal.',
        stops: [
          { name: 'Praia do Cabedelo', type: 'nature' },
          { name: 'Praia de Moledo', type: 'nature' },
          { name: 'Praia de Ofir', type: 'nature' }
        ],
        nearby: [
          { name: 'Praia de Costa Nova', type: 'nature' },
          { name: 'Praia de Miramar', type: 'nature' }
        ]
      },
      {
        day: 7,
        title: 'Gastronomía y relax',
        description: 'Disfruta de la gastronomía local y relájate antes de terminar la ruta.',
        stops: [
          { name: 'Adega do Ermitão', type: 'food' },
          { name: 'Le Babachris', type: 'food' }
        ],
        nearby: [
          { name: 'Eola | Brunch & Lunch', type: 'food' },
          { name: 'Restaurante O Barril', type: 'food' },
          { name: 'Subenshi Sushi', type: 'food' }
        ]
      }
    ]
  },
  {
    id: 'ruta-costa-da-morte-rias-baixas',
    name: 'Ruta Costa da Morte y Rías Baixas: Playas, Miradores y Sabores',
    description: 'Descubre las mejores playas, miradores y sabores de la Costa da Morte y Rías Baixas en 3 días llenos de naturaleza y gastronomía.',
    duration: 'weekend',
    days: 3,
    totalDistance: 180, // Aproximado
    difficulty: 'fácil',
    bestFor: ['parejas', 'familias', 'grupos'],
    interests: ['beach', 'nature', 'viewpoint', 'food', 'culture'],
    travelStyle: 'relaxed',
    groupSize: ['1-2', '3-4', '5+'],
    mapUrl: 'https://www.google.com/maps/d/embed?mid=1-gZ-3ENQj2j6WWLvEdVeFXxl-qQOe88&ehbc=2E312F',
    highlights: [
      'Praia das Furnas',
      'Praia de Lariño',
      'Castro de Baroña',
      'Cascada del Ézaro',
      'Faro de Fisterra'
    ],
    itinerary: [
      {
        day: 1,
        title: 'Playas del sur y gastronomía local',
        description: 'Explora las playas del sur y disfruta de la mejor comida local.',
        stops: [
          { name: 'Praia das Furnas', type: 'beach' },
          { name: 'Praia Aguieira', type: 'beach' },
          { name: 'Praia das Gaivotas', type: 'beach' }
        ],
        nearby: [
          { name: 'Benboa Corrubedo', type: 'food' },
          { name: 'Parque Natural das Dunas de Corrubedo e as Lagoas de Carregal e Vixán', type: 'nature' },
          { name: 'Restaurante Xanxo', type: 'food' }
        ]
      },
      {
        day: 2,
        title: 'Costa da Morte: playas y miradores',
        description: 'Recorre las playas y miradores más emblemáticos de la Costa da Morte.',
        stops: [
          { name: 'Praia de Lariño', type: 'beach' },
          { name: 'Praia de Area Maior', type: 'beach' },
          { name: 'Monte Louro', type: 'viewpoint' },
          { name: 'Castro de Baroña', type: 'culture' }
        ],
        nearby: [
          { name: 'O Asador Do Horreo', type: 'food' },
          { name: 'Pizzería Anxo', type: 'food' },
          { name: 'Restaurante Universal', type: 'food' },
          { name: 'Rodas', type: 'food' }
        ]
      },
      {
        day: 3,
        title: 'Norte: cascadas, faros y más playas',
        description: 'Descubre cascadas, faros y playas del norte de la ruta.',
        stops: [
          { name: 'Cascada del Ézaro', type: 'nature' },
          { name: 'Faro de Fisterra', type: 'viewpoint' },
          { name: 'Praia de Merexo', type: 'beach' },
          { name: 'Playas de Trece', type: 'beach' }
        ],
        nearby: [
          { name: 'Faro Touriñán', type: 'viewpoint' },
          { name: 'Muxía', type: 'town' },
          { name: 'Mirador do Monte do Castro Monte Facho', type: 'viewpoint' },
          { name: 'Castillo de Vimianzo', type: 'culture' },
          { name: 'Hotel La Marina Cee - Restaurante Gastronómico', type: 'food' },
          { name: 'restaurante codium_quenxe', type: 'food' },
          { name: 'Restaurante Landua', type: 'food' },
          { name: 'Restaurante El Semáforo de Finisterre', type: 'food' }
        ]
      }
    ]
  },
  {
    id: 'ruta-costa-da-morte-rias-baixas-semana',
    name: 'Ruta Costa da Morte y Rías Baixas: 7 días de playas, miradores y sabores',
    description: 'Una semana completa explorando playas, miradores, cascadas y gastronomía de la Costa da Morte y Rías Baixas.',
    duration: 'week',
    days: 7,
    totalDistance: 350, // Aproximado
    difficulty: 'fácil',
    bestFor: ['parejas', 'familias', 'grupos'],
    interests: ['beach', 'nature', 'viewpoint', 'food', 'culture'],
    travelStyle: 'relaxed',
    groupSize: ['1-2', '3-4', '5+'],
    mapUrl: 'https://www.google.com/maps/d/embed?mid=1-gZ-3ENQj2j6WWLvEdVeFXxl-qQOe88&ehbc=2E312F',
    highlights: [
      'Praia das Furnas',
      'Praia de Lariño',
      'Castro de Baroña',
      'Cascada del Ézaro',
      'Faro de Fisterra',
      'Monte Louro',
      'Playas de Trece'
    ],
    itinerary: [
      {
        day: 1,
        title: 'Playas del sur',
        description: 'Comienza la ruta en las playas del sur de la Ría de Muros y Noia.',
        stops: [
          { name: 'Praia das Furnas', type: 'beach' },
          { name: 'Praia Aguieira', type: 'beach' }
        ],
        nearby: [
          { name: 'Benboa Corrubedo', type: 'food' },
          { name: 'Parque Natural das Dunas de Corrubedo e as Lagoas de Carregal e Vixán', type: 'nature' }
        ]
      },
      {
        day: 2,
        title: 'Playas y gastronomía local',
        description: 'Disfruta de más playas y prueba la gastronomía local.',
        stops: [
          { name: 'Praia das Gaivotas', type: 'beach' },
          { name: 'Praia de Broña', type: 'beach' }
        ],
        nearby: [
          { name: 'Restaurante Xanxo', type: 'food' },
          { name: 'Taberna Da Pepa', type: 'food' }
        ]
      },
      {
        day: 3,
        title: 'Costa da Morte: Lariño y Area Maior',
        description: 'Explora las playas de Lariño y Area Maior y sube al Monte Louro.',
        stops: [
          { name: 'Praia de Lariño', type: 'beach' },
          { name: 'Praia de Area Maior', type: 'beach' },
          { name: 'Monte Louro', type: 'viewpoint' }
        ],
        nearby: [
          { name: 'O Asador Do Horreo', type: 'food' },
          { name: 'Pizzería Anxo', type: 'food' }
        ]
      },
      {
        day: 4,
        title: 'Baroña y miradores',
        description: 'Visita el Castro de Baroña y disfruta de los miradores de la zona.',
        stops: [
          { name: 'Castro de Baroña', type: 'culture' },
          { name: 'Mirador de Curota', type: 'viewpoint' },
          { name: 'Miradoiro Pedra da Rá', type: 'viewpoint' }
        ],
        nearby: [
          { name: 'Restaurante Universal', type: 'food' },
          { name: 'Rodas', type: 'food' }
        ]
      },
      {
        day: 5,
        title: 'Cascadas y naturaleza',
        description: 'Día de naturaleza: cascadas y pozas.',
        stops: [
          { name: 'Cascada del Ézaro', type: 'nature' },
          { name: 'As pozas do río Pedras', type: 'nature' },
          { name: 'Fervenza Toxosoutos (cascada)', type: 'nature' }
        ],
        nearby: [
          { name: 'Restaurante Curral Do Marqués', type: 'food' }
        ]
      },
      {
        day: 6,
        title: 'Playas del norte y Trece',
        description: 'Descubre las playas del norte y el entorno de Trece.',
        stops: [
          { name: 'Praia de Merexo', type: 'beach' },
          { name: 'Praia de Rebordelo', type: 'beach' },
          { name: 'Playas de Trece', type: 'beach' }
        ],
        nearby: [
          { name: 'Faro Touriñán', type: 'viewpoint' },
          { name: 'Muxía', type: 'town' }
        ]
      },
      {
        day: 7,
        title: 'Fisterra y despedida',
        description: 'Termina la ruta en Fisterra y disfruta de la gastronomía local.',
        stops: [
          { name: 'Faro de Fisterra', type: 'viewpoint' },
          { name: 'Castillo de Vimianzo', type: 'culture' }
        ],
        nearby: [
          { name: 'Hotel La Marina Cee - Restaurante Gastronómico', type: 'food' },
          { name: 'restaurante codium_quenxe', type: 'food' },
          { name: 'Restaurante Landua', type: 'food' },
          { name: 'Restaurante El Semáforo de Finisterre', type: 'food' }
        ]
      }
    ]
  },
  {
    id: 'ruta-rias-baixas',
    name: 'Ruta Rías Baixas: Playas, Gastronomía y Pueblos Marineros',
    description: 'Descubre las mejores playas, chiringuitos y pueblos marineros de las Rías Baixas en 3 días llenos de sol, mar y gastronomía.',
    duration: 'weekend',
    days: 3,
    totalDistance: 120, // Aproximado
    difficulty: 'fácil',
    bestFor: ['parejas', 'familias', 'grupos'],
    interests: ['beach', 'food', 'nature', 'culture'],
    travelStyle: 'relaxed',
    groupSize: ['1-2', '3-4', '5+'],
    mapUrl: 'https://www.google.com/maps/d/embed?mid=1-gZ-3ENQj2j6WWLvEdVeFXxl-qQOe88&ehbc=2E312F',
    highlights: [
      'Praia de Lagos',
      'Tulla beach',
      'Praia Pragueira',
      'Combarro',
      'Noite Tapas'
    ],
    itinerary: [
      {
        day: 1,
        title: 'Playas del sur y gastronomía local',
        description: 'Comienza en las playas del sur y disfruta de la mejor comida local.',
        stops: [
          { name: 'Praia de Lagos', type: 'beach', description: 'Playa preciosa con chiringuito, perfecta para dormir (pocos sitios)' },
          { name: 'Aparcamiento Playa de Ancoradouro', type: 'beach', description: 'Entre dos playas preciosas, con chiringuito que sirve pescado del día a la brasa' },
          { name: 'Tulla beach', type: 'beach', description: 'La playa más bonita de la ría, con varios chiringuitos' }
        ],
        nearby: [
          { name: 'El Balcón. Cafe-Bar', type: 'food', description: 'Perfecto para tomar algo en un lugar especial' },
          { name: 'Noite Tapas', type: 'food', description: 'SITIO espectacular para comer o cenar, dueños geniales y comida top' },
          { name: 'Restaurante Pinela - Aldán', type: 'food' }
        ]
      },
      {
        day: 2,
        title: 'Playas centrales y miradores',
        description: 'Explora las playas centrales y disfruta de las mejores vistas.',
        stops: [
          { name: 'Praia Pragueira', type: 'beach', description: 'Muy top para dormir, playa grande y preciosa' },
          { name: 'Playa de Foxos', type: 'beach' },
          { name: 'Praia de Area Grande', type: 'beach' }
        ],
        nearby: [
          { name: 'Restaurante Bico Beach', type: 'food', description: 'Chiringuito con unas vistas tremendas' },
          { name: 'Terraza Corsario', type: 'food', description: 'Gran ambiente siempre, buenas vistas desde lo alto' },
          { name: 'Casa Videira Turismo Rural', type: 'food' }
        ]
      },
      {
        day: 3,
        title: 'Combarro y playas del norte',
        description: 'Visita el pueblo marinero de Combarro y las playas del norte.',
        stops: [
          { name: 'Combarro', type: 'culture', description: 'Pueblo pesquero' },
          { name: 'Praia Mexilloeira', type: 'beach' },
          { name: 'Campo da Bouza', type: 'nature', description: 'Perfecto para dormir y estar cerca de todas las playas y chiringuitos' }
        ],
        nearby: [
          { name: 'Restaurante O Peirao', type: 'food', description: 'Marisco en un sitio de toda la vida de buena calidad y buen precios' },
          { name: 'Taberna Okra', type: 'food', description: 'Taberna Japonesa, super rico pero un poco caro' },
          { name: 'Chiringuito PataPalo', type: 'food' }
        ]
      }
    ]
  },
  {
    id: 'ruta-rias-baixas-semana',
    name: 'Ruta Rías Baixas: 7 días de playas, gastronomía y pueblos marineros',
    description: 'Una semana completa explorando las mejores playas, chiringuitos y pueblos marineros de las Rías Baixas.',
    duration: 'week',
    days: 7,
    totalDistance: 250, // Aproximado
    difficulty: 'fácil',
    bestFor: ['parejas', 'familias', 'grupos'],
    interests: ['beach', 'food', 'nature', 'culture'],
    travelStyle: 'relaxed',
    groupSize: ['1-2', '3-4', '5+'],
    mapUrl: 'https://www.google.com/maps/d/embed?mid=1-gZ-3ENQj2j6WWLvEdVeFXxl-qQOe88&ehbc=2E312F',
    highlights: [
      'Praia de Lagos',
      'Tulla beach',
      'Praia Pragueira',
      'Combarro',
      'Noite Tapas',
      'Restaurante Bico Beach',
      'Taberna Okra'
    ],
    itinerary: [
      {
        day: 1,
        title: 'Playas del sur',
        description: 'Comienza en las playas del sur de la ría.',
        stops: [
          { name: 'Praia de Lagos', type: 'beach', description: 'Playa preciosa con chiringuito, perfecta para dormir (pocos sitios)' },
          { name: 'Aparcamiento Playa de Ancoradouro', type: 'beach', description: 'Entre dos playas preciosas, con chiringuito que sirve pescado del día a la brasa' }
        ],
        nearby: [
          { name: 'El Balcón. Cafe-Bar', type: 'food', description: 'Perfecto para tomar algo en un lugar especial' },
          { name: 'Noite Tapas', type: 'food', description: 'SITIO espectacular para comer o cenar, dueños geniales y comida top' }
        ]
      },
      {
        day: 2,
        title: 'Tulla y alrededores',
        description: 'Disfruta de la playa más bonita de la ría y sus alrededores.',
        stops: [
          { name: 'Tulla beach', type: 'beach', description: 'La playa más bonita de la ría, con varios chiringuitos' },
          { name: 'Playa de Montalvo', type: 'beach' }
        ],
        nearby: [
          { name: 'Restaurante Pinela - Aldán', type: 'food' },
          { name: 'Casa Videira Turismo Rural', type: 'food' }
        ]
      },
      {
        day: 3,
        title: 'Playas centrales',
        description: 'Explora las playas centrales de la ría.',
        stops: [
          { name: 'Praia Pragueira', type: 'beach', description: 'Muy top para dormir, playa grande y preciosa' },
          { name: 'Playa de Foxos', type: 'beach' }
        ],
        nearby: [
          { name: 'Restaurante Bico Beach', type: 'food', description: 'Chiringuito con unas vistas tremendas' },
          { name: 'Terraza Corsario', type: 'food', description: 'Gran ambiente siempre, buenas vistas desde lo alto' }
        ]
      },
      {
        day: 4,
        title: 'Area Grande y alrededores',
        description: 'Visita la playa de Area Grande y sus alrededores.',
        stops: [
          { name: 'Praia de Area Grande', type: 'beach' },
          { name: 'Praia Mexilloeira', type: 'beach' }
        ],
        nearby: [
          { name: 'La Perfecta', type: 'food' },
          { name: 'A Finca de Muiño Vello', type: 'food' }
        ]
      },
      {
        day: 5,
        title: 'Combarro y pueblos marineros',
        description: 'Explora el pueblo marinero de Combarro y sus alrededores.',
        stops: [
          { name: 'Combarro', type: 'culture', description: 'Pueblo pesquero' },
          { name: 'Cabo Home', type: 'viewpoint' }
        ],
        nearby: [
          { name: 'Restaurante O Peirao', type: 'food', description: 'Marisco en un sitio de toda la vida de buena calidad y buen precios' },
          { name: 'Taberna Okra', type: 'food', description: 'Taberna Japonesa, super rico pero un poco caro' }
        ]
      },
      {
        day: 6,
        title: 'Playas del norte',
        description: 'Disfruta de las playas del norte de la ría.',
        stops: [
          { name: 'Campo da Bouza', type: 'nature', description: 'Perfecto para dormir y estar cerca de todas las playas y chiringuitos' },
          { name: 'Chiringuito PataPalo', type: 'food' }
        ],
        nearby: [
          { name: 'Parque Infantil La Aldea de los Grobits (La Toja)', type: 'nature' }
        ]
      },
      {
        day: 7,
        title: 'Último día de relax',
        description: 'Último día para relajarse y disfrutar de la gastronomía local.',
        stops: [
          { name: 'Chiringuito praia Mourisca', type: 'food' },
          { name: 'Noite Tapas', type: 'food', description: 'SITIO espectacular para comer o cenar, dueños geniales y comida top' }
        ],
        nearby: [
          { name: 'El Balcón. Cafe-Bar', type: 'food', description: 'Perfecto para tomar algo en un lugar especial' },
          { name: 'Restaurante Bico Beach', type: 'food', description: 'Chiringuito con unas vistas tremendas' }
        ]
      }
    ]
  }
];

// Helper function to infer travel style based on preferences
const inferTravelStyle = (preferences) => {
  // If user is traveling with family, prefer relaxed style
  if (preferences.groupType === 'familias') {
    return 'relaxed';
  }
  
  // If user is traveling solo or with friends and interested in mountains, prefer adventure
  if ((preferences.groupType === 'solo' || preferences.groupType === 'grupos') && 
      preferences.interests.includes('mountains')) {
    return 'adventure';
  }
  
  // Default to balanced style
  return 'balanced';
};

// Helper function to infer group size based on group type
const inferGroupSize = (groupType) => {
  switch (groupType) {
    case 'parejas':
      return '1-2';
    case 'familias':
      return '3-4';
    case 'grupos':
      return '5+';
    case 'solo':
      return '1-2';
    default:
      return '1-2';
  }
};

// Helper function to match user preferences with routes
export const findMatchingRoutes = (preferences) => {
  // Infer travel style and group size
  const inferredTravelStyle = inferTravelStyle(preferences);
  const inferredGroupSize = inferGroupSize(preferences.groupType);

  return routes.filter(route => {
    // Match duration
    if (preferences.tripDuration && route.duration !== preferences.tripDuration) {
      return false;
    }

    // Match inferred travel style
    if (route.travelStyle !== inferredTravelStyle) {
      return false;
    }

    // Match inferred group size
    if (!route.groupSize.includes(inferredGroupSize)) {
      return false;
    }

    // Match group type
    if (preferences.groupType && !route.bestFor.includes(preferences.groupType)) {
      return false;
    }

    // Match interests (at least one interest should match)
    if (preferences.interests && preferences.interests.length > 0) {
      const hasMatchingInterest = preferences.interests.some(interest => 
        route.interests.includes(interest)
      );
      if (!hasMatchingInterest) {
        return false;
      }
    }

    return true;
  });
};

// Helper function to get route recommendations based on preferences
export const getRouteRecommendations = (preferences) => {
  // Ensure preferences has all required properties
  const safePreferences = {
    tripDuration: preferences?.tripDuration,
    groupType: preferences?.groupType,
    interests: preferences?.interests || []
  };

  // 1. Strict filter by duration only
  const filteredRoutes = routes.filter(route => route.duration === safePreferences.tripDuration);

  // 2. Score by group type, interests, etc.
  return filteredRoutes
    .map(route => {
      let score = 0;
      // Group type match
      if (safePreferences.groupType && route.bestFor.includes(safePreferences.groupType)) score += 2;
      // Inferred travel style match
      const inferredTravelStyle = inferTravelStyle(safePreferences);
      if (route.travelStyle === inferredTravelStyle) score += 1;
      // Inferred group size match
      const inferredGroupSize = inferGroupSize(safePreferences.groupType);
      if (route.groupSize.includes(inferredGroupSize)) score += 1;
      // Number of matching interests
      if (safePreferences.interests.length > 0) {
        score += route.interests.filter(interest => safePreferences.interests.includes(interest)).length;
      }
      return { ...route, _score: score };
    })
    .sort((a, b) => b._score - a._score);
}; 